import { z } from 'zod';
import type { Warehouse } from './Warehouse';

export class WarehouseValidator {
    public static validateAll(warehouse: Warehouse): boolean {
        return WarehouseValidator.isNameValid(warehouse) === '' && WarehouseValidator.hasValidCoords(warehouse);
    }

    public static isNameValid(warehouse: Warehouse): string {
        try {
            z.string().min(2).parse(warehouse.getName());
        } catch (e) {
            return 'Name is too short';
        }
        return '';
    }
    
    public static hasValidCoords(warehouse: Warehouse): boolean {
        return warehouse.getX()! !== null && warehouse.getY()! !== null;
    }
}
